import { isGifUrl } from './utils'

export const getParsedMessage = (message) => {
  const parser = new DOMParser()
  const htmlText = message
  let parsedMessage = parser.parseFromString(htmlText, 'text/html')
  return parsedMessage
}

export const getTaggedUserIds = (parsedMessage) => {
  const ids = []
  const spanMentions = parsedMessage.body.querySelectorAll('span[class="mention"]')

  if (spanMentions?.length > 0) {
    for (let i = 0; i < spanMentions.length; i++) {
      ids.push(spanMentions[i].dataset.id)
    }
  }
  if (ids.length > 0) {
    return ids.join(',')
  }
  return ''
}

export const getLinksFromMessage = (parsedMessage) => {
  const links = []

  const anchorLinks = parsedMessage.body.querySelectorAll('a')

  if (anchorLinks?.length > 0) {
    for (let i = 0; i < anchorLinks.length; i++) {
      links.push(anchorLinks[i].href)
    }
  }
  if (links.length > 0) {
    return links.join(',')
  }
  return ''
}

export const trimDivsFromMessage = (originalMessage, parsedMessage, template, isAutoMessage) => {
  const messageChildDivs = parsedMessage?.body?.childNodes
  if (messageChildDivs) {
    const arrayMessageDivs = [...messageChildDivs]
    if (template === 'standard' && isAutoMessage === 0) {
      // remove empty lines (div with only br tag) from start and end of the message
      while (arrayMessageDivs.length > 0 && arrayMessageDivs[0].innerHTML?.trim() === '<br>') {
        arrayMessageDivs.shift()
      }
      while (
        arrayMessageDivs.length > 0 &&
        arrayMessageDivs[arrayMessageDivs.length - 1].innerHTML?.trim() === '<br>'
      ) {
        arrayMessageDivs.pop()
      }
      return arrayMessageDivs.map((div) => div.outerHTML).join('')
    }
  }
  return originalMessage
}

export const isMessageGiftLink = (parsedMessage) => {
  //conditions: message is a considered as gif link if
  //1. feed contains only links which end with .gif extention
  //2. feed should not contain any other words
  //3. div with only break will be ignored
  const messageChildDivs = parsedMessage?.body?.childNodes
  if (messageChildDivs) {
    const arrayMessageDivs = [...messageChildDivs]
    const messageWithoutAllEmptyLine = arrayMessageDivs.filter((div) => div?.innerHTML !== '<br>')
    const allLinksAreGifImages = messageWithoutAllEmptyLine.every((div) => {
      if (div?.childNodes?.length === 1) {
        const anchorTag = div.childNodes[0]
        return anchorTag && anchorTag.href && isGifUrl(anchorTag.href)
      }
      return false
    })
    return allLinksAreGifImages
  }
  return false
}

export const isMessageWithAllLinks = (parsedMessage) => {
  //conditions: message is a considered as gif link if
  //1. feed contains only links which end with .gif extention
  //2. feed should not contain any other words
  //3. div with only break will be ignored
  const messageChildDivs = parsedMessage?.body?.childNodes
  if (messageChildDivs) {
    const arrayMessageDivs = [...messageChildDivs]
    const messageWithoutAllEmptyLine = arrayMessageDivs.filter((div) => div?.innerHTML !== '<br>')
    const allLinks = messageWithoutAllEmptyLine.every((div) => {
      if (div?.childNodes?.length === 1) {
        const anchorTag = div.childNodes[0]
        return anchorTag && anchorTag.href ? true : false
      }
      return false
    })
    return allLinks
  }
  return false
}

export const getParentFeed = (feedId, allFeeds) => {
  let found = null
  if (allFeeds?.length > 0) {
    for (let i = 0; i < allFeeds.length; i++) {
      const parentFeed = allFeeds[i]
      if (parentFeed?.responses?.length > 0) {
        for (let j = 0; j < parentFeed.responses.length; j++) {
          const response = parentFeed.responses[j]
          if (response.origin_message_id == feedId) {
            return parentFeed
          } else if (response.responses) {
            for (let k = 0; k < response.responses.length; k++) {
              const nestedResponse = response.responses[k]
              if (nestedResponse.origin_message_id == feedId) {
                return response
              }
            }
          }
        }
      }
    }
  }
  return found
}

export const getParentFeedIdFromFeed = (feedId, feed) => {
  let found = 0
  if (feed && feed.responses) {
    feed.responses.forEach((response) => {
      if (response.id == feedId) {
        found = response.origin_message_id
        return
      } else if (response.responses) {
        response.responses.forEach((nestedResponse) => {
          if (nestedResponse.id == feedId) {
            found = nestedResponse.origin_message_id
            return
          }
        })
      }
    })
  }
  return found
}

export const getChildFeed = (feedIdToSearch, allFeeds) => {
  let found = null
  if (allFeeds?.length > 0) {
    for (let i = 0; i < allFeeds.length; i++) {
      const parentFeed = allFeeds[i]
      if (parentFeed?.responses?.length > 0) {
        for (let j = 0; j < parentFeed.responses.length; j++) {
          const response = parentFeed.responses[j]
          if (response.id == feedIdToSearch) {
            return response
          } else if (response.responses) {
            for (let k = 0; k < response.responses.length; k++) {
              const nestedResponse = response.responses[k]
              if (nestedResponse.id == feedIdToSearch) {
                return nestedResponse
              }
            }
          }
        }
      }
    }
  }
  return found
}

//this function returns comment id/ reply id based on parent feed id.
//parent feed id can be main parent feed id or comment id
//this function is called after comment or reply is posted
export const getPostedResponseId = (allFeedList, parentFeedId) => {
  if (allFeedList.length > 0) {
    for (let i = 0; i < allFeedList.length; i++) {
      if (allFeedList[i].id == parentFeedId) {
        const comments = allFeedList[i].responses
        if (comments?.length > 0) {
          const latestComment = comments[comments.length - 1]
          return latestComment.id
        }
      } else {
        const comments = allFeedList[i].responses
        if (comments?.length > 0) {
          for (let j = 0; j < comments.length; j++) {
            if (comments[j].id == parentFeedId) {
              const replies = comments[j].responses
              if (replies?.length > 0) {
                const latestReply = replies[replies.length - 1]
                return latestReply.id
              }
            }
          }
        }
      }
    }
  }
  return 0
}

export const scrollToElement = (elementToScroll, level, timeout) => {
  if (elementToScroll) {
    elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'center' })
    elementToScroll.style.backgroundColor = '#d4d4e0'
    elementToScroll.style.borderRadius = level === 1 ? '32px' : '20px'
    elementToScroll.style.marginBottom = '8px'
    setTimeout(() => {
      elementToScroll.style.backgroundColor = '#fff'
      elementToScroll.style.transition = 'all 1s'
      if (level !== 1) {
        elementToScroll.style.borderRadius = '0'
      }
      elementToScroll.style.marginBottom = '0'
    }, timeout)
  }
}
